import * as ng from 'angular';
import {IPromise} from 'angular';
import * as Linq from 'linq-es5';
import {ComponentRegistration} from '../../core';
import {Dto, IFrequentParkerAccountResource, IParkingMediaRequestResource, IParkingMediaResource} from '../../data';
import {IContentTemplateResource} from '../../data/content-template'
import {Moment} from 'moment';
import {ICustomerSettingsService, ISessionService, ISessionState, IToastMessageService} from '../../services';
import {Templates} from "../../assets";

let template = require('./media.html');

class MediaComponent extends ComponentRegistration {

    constructor() {
        super('media', {
            controller: MediaController,
            templateUrl: template,
            controllerAs: 'media',
            $canActivate : function($injector) : IPromise<boolean> {
                var sessionService: ISessionService = $injector.get('Session');
                var $q: ng.IQService = $injector.get('$q');

                return sessionService.getSessionAsync().then((session) =>
                    {
                        if (session && session.account && session.account.isReservedParking) {
                            // Lets add a route definition for media only if the account is reserved parking.
                            return $q.resolve(true);
                        }
                        else
                        {
                            console.error("Access to media tab is denied.");
                            return  $q.resolve(false);
                        }
                    }
                ).catch((e) => {
                    console.error(e);
                    console.error("Failed to load session data. Access to media tab is denied.");
                    return  $q.resolve(false);
                });
            },
            bindings: {
            }
        });
    }
}

interface IMediaController {
    onCancelClick(): void;
    onSaveClick(args): void;
    onEditClick(): void;
    onRequestClick(): void;
    onCancelRequestClick(): void;
    onSubmitRequestClick(args): void;
    calculateTotal(): void;
    saveMediaRequest(args): any;
    isFrequentParkerAccount: Boolean;
}

class MediaController implements IMediaController {
    private static $inject: Array<string> = ['$q', '$scope', 'ParkingMedia', 'ParkingMediaRequest', 'Session', 'toastMessageFactory', 'moment', 'ContentTemplate', 'FrequentParkerAccount', 'CustomerSettings'];

    private mediaRequestTemplateUrl: string = Templates.mediaRequest;
    private session: ISessionState;
    private parkingMediaList: Array<any> = [];
    private parkingMediaRequests: Array<Dto.IParkingMediaRequest> = [];
    private totalCost: number = 0;
    private isReadOnly: boolean = true;
    private showRequest: boolean = false;
    private isReplaceExisting: boolean = false;
    private replaceExistingSelectedIndex = null;
    private existsActiveMedia: boolean = true;
    private isLostorStolen: boolean = false;
    private replaceReason = null;
    private key: string = Dto.ContentTypeSettingKeys[Dto.ContentTypeSettingKeys.MediaRequest];
    private language: string = 'en';
    public content: string;
    private _isFrequentParkerAccountEnabled: boolean;
    private fpAccount: Dto.IFrequentParkerAccount;
    
    private oriParkingMediaList: Array<any> = [];

    constructor(private $q: ng.IQService,
        private $scope: ng.IScope,
        private ParkingMedia: IParkingMediaResource,
        private ParkingMediaRequest: IParkingMediaRequestResource,
        private Session: ISessionService,
        private toastMessageFactory: IToastMessageService,
        private moment: Moment,
        private ContentTemplate: IContentTemplateResource,
        private FrequentParkerAccountResource: IFrequentParkerAccountResource,
        private CustomerSettings: ICustomerSettingsService) {

        console.log('MediaController loading');
    }
 
    public $onInit(): void {
        if (!this.Session.assureActiveUserSession()) return;
        let self = this;
        this.Session.getSessionAsync()
            .then((session) => {
                self.session = session;
                var criteria = {
                    accountId: session.account.id,
                    userProfileId: session.profile.id,
                    disabled: false
                }

                self.fpAccount = session.frequentParkerAccount;

                self.CustomerSettings.getFrequentParkerSettings().then((response) => {
                    self._isFrequentParkerAccountEnabled = response.settings.enabled;
                });
                            
                self.ParkingMedia.query({ accountId: session.account.id }, criteria).$promise
                    .then((response) => {
                        self.parkingMediaList = response;
                        self.existsActiveMedia = Linq.from(self.parkingMediaList).Any((x: any) => { return !x.disabled });
                        self.oriParkingMediaList = ng.copy(self.parkingMediaList);

                    })
                    .catch((e) => { console.log(e); });
                
            })
            .catch((e) => {
                console.error(e);
                console.error('Failed to load session data.');
            }
        );
       
        this.$scope.$watch("media.parkingMediaRequests", () => { self.calculateTotal() }, true);

        console.log('MediaController loaded');
     }

     public get isFrequentParkerAccount() : Boolean {
         // returning (this._isFrequentParkerAccountEnabled && this.session && this.session.frequentParkerAccount) results in compiler
         // error related to conversion to bool.
         if (this._isFrequentParkerAccountEnabled && this.session && this.session.frequentParkerAccount)
             return  true;

         return  false;
     }

    public autoRedemptionValueChanged() {
        if (this.fpAccount && this.fpAccount.automaticRedemption === true)
            this.fpAccount.usePointsNextVisit = false;
    }

    public onCancelClick(): void {
        this.parkingMediaList = ng.copy(this.oriParkingMediaList);
        (this.$scope as any).parkingMediaForm.$setPristine();
        this.isReadOnly = true;
    }

    public onSaveClick(args): void {
        var promises = this.getMediaListSavePromises(args);
        promises.push(this.getFpAccountSavePromise(args));

        this.$q.all(promises)
            .then((response) => {
                // all parkingMedia(s) updated
                this.oriParkingMediaList = ng.copy(this.parkingMediaList);
                this.toastMessageFactory.showSuccessMessage();
                this.isReadOnly = true;
                this.existsActiveMedia = Linq.from(this.parkingMediaList).Any((x: any) => { return !x.disabled });
                console.log('MediaController: all parkingMedia in List saved');
            })
            .catch((e) => {
                this.isReadOnly = false;
                args.cancel();
                console.log(e);
            })
            .finally(() => {
            });
    }

    public onEditClick(): void {
        this.isReadOnly = false;
    }

    public onRequestClick(): void {
        this.showRequest = !this.showRequest;
        this.ContentTemplate.query({ key: this.key, languageCode: this.language }).$promise
            .then((response) => {
                let template = Linq.From(response).FirstOrDefault();
                this.content = template.content;
            })
            .catch((e) => {
                console.log(e);
            });   
    }

    public onCancelRequestClick(): void {
        this.showRequest = false;
        this.isReplaceExisting = false;
        this.replaceExistingSelectedIndex = null;
        this.replaceReason = null;
        (this.$scope as any).parkingForm.$setPristine();
    }

    public onSubmitRequestClick(args): void {
        if (this.isReplaceExisting) {
            this.onSaveClick(args);
        }
        this.saveMediaRequest(args);
    }
    
    public calculateTotal(): void {
        var mediaList = Linq.from(this.parkingMediaRequests);
        this.totalCost = mediaList.Sum((x) => { return (x as any).type.price * x.quantity; });
    }

    public saveMediaRequest(args): any {
        var parkingMediaRequests = ng.copy(this.parkingMediaRequests);
        parkingMediaRequests = Linq.from(parkingMediaRequests)
            .Where((x) => { return x.quantity > 0 }).ToArray();

        if (this.isReplaceExisting && parkingMediaRequests.length > 1) {

            // We should never get here, however lets make sure we are not sending more then one, in case the validation failed to catch this.
            // Note, the server never checks that only one replacement is sent, since each erquest is saved in a separate API call.

            parkingMediaRequests.splice(1, parkingMediaRequests.length - 1);
        }
        
        var promises = [];
        ng.forEach(parkingMediaRequests, (parkingMediaRequest) => {
            parkingMediaRequest.accountId = this.session.account.id;
            parkingMediaRequest.userProfileId = this.session.profile.id

            if (this.isReplaceExisting) {
                parkingMediaRequest.replaceParkingMediaId = this.replaceExistingSelectedIndex;
            }
            promises.push(
                this.ParkingMediaRequest.insert({ accountId: this.session.account.id }, parkingMediaRequest)
                    .$promise
                    .then((response) => {
                        // single parkingMediaRequest insert
                        console.log('MediaController:single parkingMediaRequest saved');
                    })
                    .catch((e) => {
                        this.isReadOnly = false;
                        args.cancel();
                        console.log(e);
                    })
                    .finally(() => {
                    })
            );
        });
        return this.$q.all(promises)
            .then((response) => {
                // all parkingMediaRequests(s) inserted
                this.toastMessageFactory.showSuccessMessage();
                this.showRequest = false;
                this.isReplaceExisting = false;
                this.replaceExistingSelectedIndex = null;
                this.replaceReason = null;
                this.existsActiveMedia = Linq.from(this.parkingMediaList).Any((x: any) => { return !x.disabled });
                console.log('MediaController:all parkingMediaRequests in List saved');
            })
            .catch((e) => {
                this.isReadOnly = false;
                args.cancel();
                console.log(e);
            })
            .finally(() => {
            });
    }

    private getMediaListSavePromises(args): any[] {
        var promises = [];
        ng.forEach(this.parkingMediaList, (parkingMedia) => {

            if (parkingMedia.disabledReasonId === 2) {
                parkingMedia.disabled = true;
            } else if (parkingMedia.disabledReasonId === 0) {
                parkingMedia.disabledReasonId = null;
            }

            if (this.isReplaceExisting && this.replaceExistingSelectedIndex === parkingMedia.id) {
                parkingMedia.disabled = true;
                parkingMedia.disabledReasonId = this.replaceReason;
            }

            if (parkingMedia.disabled) {
                parkingMedia.disabledDateTime = (this.moment as any)().endOf('day').toDate();
                parkingMedia.expirationDate = (this.moment as any)().endOf('day').toDate();
            }

            promises.push(
                this.ParkingMedia.update({ id: parkingMedia.id, accountId: this.session.account.id }, parkingMedia)
                    .$promise
                    .then((response) => {
                        // single parkingMedia update
                        console.log('MediaController: single parkingMedia saved');
                    })
                    .catch((e) => {
                        this.isReadOnly = false;
                        args.cancel();
                        console.log(e);
                    })
                    .finally(() => {
                    })
            );
        });

        return promises;
    }

    private getFpAccountSavePromise(args): any {
        if (!this.fpAccount) return;

        var params = { id: this.fpAccount.id, accountId: this.fpAccount.accountId };
        return this.FrequentParkerAccountResource.update(params, this.fpAccount).$promise
            .then((response) => {
                console.log(response);
            })
            .catch((e) => {
                this.isReadOnly = false;
                args.cancel();
                console.log(e);
            });
    }
}

let medComponent = new MediaComponent();
export default medComponent;
export { medComponent as MediaComponent, IMediaController, MediaController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/dashboard/media.ts